import { MenuItem } from "@chakra-ui/react";
import type { ProjectListNavbarStore } from "@components/modules/projects/list/components/navbar/store";
import { Trans } from "@lingui/macro";
import { observer } from "mobx-react-lite";

type ExportMlggkProjectsEffectivenessButtonProps = {
  store: ProjectListNavbarStore;
};

export const ExportMlggkProjectsEffectivenessButton = observer(
  function ExportMlggkProjectsEffectivenessButton({
    store,
  }: ExportMlggkProjectsEffectivenessButtonProps) {
    if (store.isMlggkProjectsEffectivenessExportDisabled) {
      return null;
    }

    return (
      <MenuItem
        isDisabled={store.isExporting}
        onClick={store.exportMlggkProjectsEffectiveness}
      >
        <Trans>MLGGK Effectiveness</Trans>
      </MenuItem>
    );
  },
);
